import { render, staticRenderFns } from "./PatSignUpPage.vue?vue&type=template&id=23cfd196"
import script from "./PatSignUpPage.vue?vue&type=script&lang=js"
export * from "./PatSignUpPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports